<label class="ac-input ac-checkbox">
	<input type="checkbox" (change)="onScenarioSelectionClick($event)" [checked]="isSelected" />
	<span class="scenario-name">
		<div>
			<span class="featured-label"> <span class="text-bold" dcrHTMLKey="FEATURED_SCENARIO_LABEL">FEATURED!</span> &nbsp; </span>
			<span [innerHTML]="scenario.formattedValue"> </span>
			<icon
				type="info-circle"
				class="info-circle info-bubble"
				*ngIf="showInfoBubbles && scenario.attribute['infoBubble']"
				[tooltip]="infoBubble"
				[analytic-data]="{ linkName: 'tooltip_' + scenario.rawValue }"
			></icon>
			<ng-template #infoBubble><section [innerHTML]="scenario.attribute['infoBubble']"></section></ng-template>
		</div>
	</span>
</label>
